import { call, put, select } from 'redux-saga/effects';
import { urls } from '../../../common/urls';
import { getHttp, getHttpwithtoken, postHttpwithtoken } from '../../../common/ApiCall';
import {
  getVehicleTypeFailure,
  getVehicleTypeLoading,
  getVehicleTypeSuccess,
  getBrandsByVehicleFailure,
  getBrandsByVehicleLoading,
  getBrandsByVehicleSuccess,
  getModalByBrandFailure,
  getModalByBrandLoading,
  getModalByBrandSuccess,
  vehicleRegistrationFailure,
  vehicleRegistrationLoading,
  vehicleRegistrationSuccess,
  editVehicleFailure,
  editVehicleLoading,
  editVehicleSuccess,
  vehicleSubTypeFailure,
  vehicleSubTypeLoading,
  vehicleSubTypeSuccess,
  RatePredictorFailure,
  RatePredictorSuccess,
  RatePredictorLoading,
  addVehicleFailure,
  addVehicleLoading,
  addVehicleSuccess,
} from '../../ducks/VehicleSlice';

// Get Vehicle Type Handler
export function* handlerGetVehicleType(action: any): Generator<any, void, any> {
  try {
    yield put(getVehicleTypeLoading());
    const response: any = yield call(getHttpwithtoken, `${urls.baseURL}${urls.vehicaltype}`);
    
    if (response.success) {
      yield put(getVehicleTypeSuccess(response.data));
    } else {
      yield put(getVehicleTypeFailure(response.message || 'Failed to get vehicle types'));
    }
  } catch (error: any) {
    yield put(getVehicleTypeFailure(error.message || 'Failed to get vehicle types'));
  }
}

// Get Brands by Vehicle Handler
export function* handlerGetBrandsByVehicleList(action: any): Generator<any, void, any> {
  try {
    yield put(getBrandsByVehicleLoading());
    const response: any = yield call(getHttpwithtoken, `${urls.baseURL}${urls.getBrandByVehicleId}?vehicle_id=${action.payload}`);
    
    if (response.success) {
      yield put(getBrandsByVehicleSuccess(response.data));
    } else {
      yield put(getBrandsByVehicleFailure(response.message || 'Failed to get brands'));
    }
  } catch (error: any) {
    yield put(getBrandsByVehicleFailure(error.message || 'Failed to get brands'));
  }
}

// Get Modal by Brand Handler
export function* handlerGetModalByBrandsList(action: any): Generator<any, void, any> {
  try {
    yield put(getModalByBrandLoading());
    const response: any = yield call(getHttpwithtoken, `${urls.baseURL}${urls.modellist}?brand_id=${action.payload}`);
    
    if (response.success) {
      yield put(getModalByBrandSuccess(response.data));
    } else {
      yield put(getModalByBrandFailure(response.message || 'Failed to get models'));
    }
  } catch (error: any) {
    yield put(getModalByBrandFailure(error.message || 'Failed to get models'));
  }
}

// Vehicle Registration Handler
export function* handlerVehicleRegistration(action: any): Generator<any, void, any> {
  try {
    yield put(vehicleRegistrationLoading());
    const response: any = yield call(postHttpwithtoken, `${urls.baseURL}${urls.vehicleregistrationdetail}`, action.payload);
    
    if (response.success) {
      yield put(vehicleRegistrationSuccess(response.data));
    } else {
      yield put(vehicleRegistrationFailure(response.message || 'Vehicle registration failed'));
    }
  } catch (error: any) {
    yield put(vehicleRegistrationFailure(error.message || 'Vehicle registration failed'));
  }
}

// Edit Vehicle Handler
export function* handlerEditVehicle(action: any): Generator<any, void, any> {
  try {
    yield put(editVehicleLoading());
    const response: any = yield call(postHttpwithtoken, `${urls.baseURL}${urls.editvehicle}${action.payload.id}`, action.payload.data);
    
    if (response.success) {
      yield put(editVehicleSuccess(response.data));
    } else {
      yield put(editVehicleFailure(response.message || 'Vehicle update failed'));
    }
  } catch (error: any) {
    yield put(editVehicleFailure(error.message || 'Vehicle update failed'));
  }
}

// Vehicle Sub Type Handler
export function* handlerVehicleSubType(action: any): Generator<any, void, any> {
  try {
    yield put(vehicleSubTypeLoading());
    const response: any = yield call(getHttpwithtoken, `${urls.baseURL}${urls.vehicaltype}?parent_id=${action.payload}`);
    
    if (response.success) {
      yield put(vehicleSubTypeSuccess(response.data));
    } else {
      yield put(vehicleSubTypeFailure(response.message || 'Failed to get vehicle sub types'));
    }
  } catch (error: any) {
    yield put(vehicleSubTypeFailure(error.message || 'Failed to get vehicle sub types'));
  }
}

// Rate Predictor Handler
export function* handlerRatePredictor(action: any): Generator<any, void, any> {
  try {
    yield put(RatePredictorLoading());
    const response: any = yield call(postHttpwithtoken, `${urls.baseURL}${urls.distanceMeter}`, action.payload);
    
    if (response.success) {
      yield put(RatePredictorSuccess(response.data));
    } else {
      yield put(RatePredictorFailure(response.message || 'Rate prediction failed'));
    }
  } catch (error: any) {
    yield put(RatePredictorFailure(error.message || 'Rate prediction failed'));
  }
}

// Add Vehicle Handler
export function* handlerAddVehicle(action: any): Generator<any, void, any> {
  try {
    yield put(addVehicleLoading());
    const response: any = yield call(postHttpwithtoken, `${urls.baseURL}${urls.addvehicle}`, action.payload);
    
    if (response.success) {
      yield put(addVehicleSuccess(response.data));
    } else {
      yield put(addVehicleFailure(response.message || 'Failed to add vehicle'));
    }
  } catch (error: any) {
    yield put(addVehicleFailure(error.message || 'Failed to add vehicle'));
  }
}
